module.exports = __webpack_public_path__ + "assets/group-11.bd412cb362d5eaa842feb3b5ff619992.png";